import { node, string } from "prop-types";

import cx from "classnames";

const propTypes = {
  href: string,
  children: node.isRequired,
  className: string,
  target: string,
};

const CallToAction = (props) => {
  const { children, className, href, target } = props;

  return (
    <a
      className={cx("call-to-action", className)}
      href={href ? href : "#1"}
      target={target ? target : "_self"}
    >
      {children}
    </a>
  );
};

CallToAction.propTypes = propTypes;
export default CallToAction;
